import { ElementHelpers } from'../../helpers/element-helpers';

/**
 * Overall input class, used as base class for all input elements
 */
export class Input {

	/**
	 * @param {HTMLElement} elem - input element
	 * @param {HTMLElement} form - the form, the current element belongs to
	 * @constructor
	 */
	constructor(elem, form) {
		this.elem = elem;
		this.holder = ElementHelpers.getParentByClass(this.elem, 'form-group');
		this.form = form;
		this.feedbackHolder = this.holder.querySelector('.form-group__feedback');
		this.valid = null;

		this.hasErrorMsg = false;
		this.hasInput = false;
		this.clearButton = this.holder.querySelector('.icon--clear');
		this.eyeButton = this.holder.querySelector('.icon--eye');
	}

	static get STATES() {
		return {
			DISABLED: 'form-group--disabled',
			ERROR: 'form-group--error',
			HAS_FOCUS: 'form-group--focus',
			DEFAULT: 'form-group',
			NO_CONTENT: 'form-group--no-content',
			VALID: 'form-group--valid',
			HAS_INPUT: 'form-group--has-input'
		}
	}

	get needValidation() {
		return this.form && this.form.elem && this.form.validationUrl && this.elem.hasAttribute('data-validate');
	}

	/**
	 * add all event handlers
	 *
	 * @returns {void}
	 */
	addEventHandlers() {
		this.elem.addEventListener('change', () => {
			if (this.needValidation) {
				this.validate();
			}
		});

		if(this.clearButton){
			this.clearButton.addEventListener('click', () => {
				this.clearField();
			})
		}

		if(this.eyeButton){
			this.eyeButton.addEventListener('click', () => {
				this.togglePassword();
			})
		}

		this.elem.addEventListener('input', () => {
			this.handleInputText();
		});

		this.elem.addEventListener('focus', () => {
			this.onFocusElem();
		});
		this.elem.addEventListener('blur', () => {
			this.onBlurElem();
		});
	}

	onBlurElem() {
		// Added a timeout, because else the 'Clear field' icon would disappear before you could click it.
		setTimeout(() => {
			this.holder.classList.remove(Input.STATES.HAS_FOCUS);
			if (this.validation) {
				this.validate();
			}
		}, 200);
	}

	onFocusElem() {
		this.holder.classList.remove(Input.STATES.ERROR);
		this.holder.classList.add(Input.STATES.HAS_FOCUS);
	}

	validate() {
		this.form.validation.validateInput(this.elem).then((data) => {
			this.handleValidationResponse(data);
		});
	}

	handleValidationResponse(data) {
		const response = Object.keys(data);
		if (response.length) {
			this.setError(data[response].localizedMessage);
		} else {
			this.removeError();
		}
	}

	setError(message) {
		this.valid = false;
		if (this.form.validation.errors.indexOf(this.elem.name) === -1) {
			this.form.validation.errors.push(this.elem.name);
		}
		if (this.feedbackHolder) {
			this.holder.classList.add(Input.STATES.ERROR);
			this.holder.classList.remove(Input.STATES.VALID);
			if(!this.hasErrorMsg){
				this.hasErrorMsg = true;
				let errorMsg = document.createElement('span');
				errorMsg.classList.add('form-group__errormsg');
				errorMsg.innerHTML = message;
				this.elem.parentNode.insertBefore(errorMsg, this.feedbackHolder);
			}
		}
	}

	removeError() {
		this.valid = true;
		const index = this.form.validation.errors.indexOf(this.elem.name);
		if (index > -1) {
			this.form.validation.errors.splice(index, 1);
		}
		if (this.feedbackHolder) {
			this.holder.classList.add(Input.STATES.VALID);
			this.holder.classList.remove(Input.STATES.ERROR);
			if (this.hasErrorMsg){
				let errorMsg = this.elem.parentNode.querySelector('.form-group__errormsg') || '';
				ElementHelpers.removeElement(errorMsg);
				this.hasErrorMsg = false;
			}
		}
	}

	handleInputText(){
		if (this.elem.value !== '' && !this.hasInput) {
			this.hasInput = true;
			this.holder.classList.add(Input.STATES.HAS_INPUT);
		} else if (this.elem.value === '') {
			this.hasInput = false;
			this.holder.classList.remove(Input.STATES.HAS_INPUT);
		}
	}

	clearField() {
		this.elem.value = '';
		this.hasInput = false;
		this.holder.classList.remove(Input.STATES.HAS_INPUT);
		this.holder.classList.add(Input.STATES.NO_CONTENT);
	}

	togglePassword() {
		if (this.elem.type === 'password') {
			this.elem.type = 'text';
		} else {
			this.elem.type = 'password';
		}
	}

}
